/**
Author - Brijesh Pandey
Git - https://github.com/Brijesh-Pandey
**/

const Nominee = {
  title: 'What is a Nominee?',
  subtext: '',
  description: `<ul>
        <li>A nominee is someone you trust who can handle your investments in an event of unforeseen circumstances</li>
        <li><b>Why is this important?</b> It makes things easier for your family - they won't have to deal with complicated paperwork or long waiting periods.</li>
        <li>Don't have all the details right now? That's okay! You can add or update nominee information anytime later in your profile section</li>
        <li>If you want to add nominee details now, we'll ask for: 
          <ul>
            <li>Their phone number and email</li>
            <li>How they're related to you</li>
            <li>Their ID number (like Aadhaar / PAN / Indian Passport)</li>
            <li>Their address, etc.</li>
          </ul>
        </li>
    </ul>`,
};

export {Nominee};
